import { makeAutoObservable } from 'mobx'

export default class BooleanState {
   opened

   constructor(initial?: boolean) {
      this.opened = initial ?? false
      makeAutoObservable(this)
   }

   toggle = () => {
      if (this.opened) {
         this.close()
      } else {
         this.open()
      }
   }

   open = () => {
      this.opened = true
   }

   close = async () => {
      this.opened = false
   }
}
